// Backendless sync types. v1: a Y.Doc backed by IndexedDB + a P2P mesh that
// uses the same Awareness API as y-websocket so the rest of the app — Canvas,
// PresenceStrip, useAwareness — keeps working unchanged.

export type ConnectionStatus =
  | 'loading' // IndexedDB hasn't replayed yet
  | 'ready'   // doc is hydrated, no peers
  | 'live';   // at least one peer connected

export interface PeerInfo {
  // Stable peer identifier generated per browser tab. Used to route signaling
  // and dedupe duplicate invites.
  peerId: string;
  connectedAt: number;
}

// Lightweight container for the manual signaling payload that gets squeezed
// through a URL fragment (offer) or a short pasteable code (answer). The
// `peerId` is carried alongside the SDP so the receiver can attribute the
// connection in the "Pending joins" UI before any data channel opens.
export interface SignalingPayload {
  kind: 'offer' | 'answer';
  peerId: string;
  sdp: string;
  // Schema version so future format changes can reject gracefully.
  v: 1;
}

// Hard cap from spec §1: 4–10 concurrent users. The mesh refuses new
// invites past this number to keep the n*(n-1)/2 connection count sane.
export const MAX_PEERS = 10;
